// @flow

import { combineReducers } from 'redux'
import authenticatedRequest from './authenticated-request'
import { addErrorNotification } from './notification-manager'
import moment from 'moment'
// $FlowFixMe
import 'moment/locale/it'

import { createDataGridReducer, type DataGridState } from 'react-redux-components'
import type { Dispatch, GetState, ReduxAction, ReduxState } from './index'
import type { NetError } from './authenticated-request'
import type { CardSummary } from './campaigns'

// Action types
export const TOGGLE_FILTER: 'report/TOGGLE_FILTER' = 'report/TOGGLE_FILTER'
export const CHANGE_CHART_SAMPLING: 'report/CHANGE_CHART_SAMPLING' = 'report/CHANGE_CHART_SAMPLING'
export const CHANGE_CHART_TYPE: 'report/CHANGE_CHART_TYPE' = 'report/CHANGE_CHART_TYPE'
export const CHANGE_CHART_BRUSH_STATE: 'report/CHANGE_CHART_BRUSH_STATE' = 'report/CHANGE_CHART_BRUSH_STATE'
export const CHANGE_REPORT_START_DATE: 'report/CHANGE_REPORT_START_DATE' = 'report/CHANGE_REPORT_START_DATE'
export const FETCH_DATA_PENDING: 'report/FETCH_DATA_PENDING' = 'report/FETCH_DATA_PENDING'
export const FETCH_DATA_SUCCESS: 'report/FETCH_DATA_SUCCESS' = 'report/FETCH_DATA_SUCCESS'
export const FETCH_DATA_ERROR: 'report/FETCH_DATA_ERROR' = 'report/FETCH_DATA_ERROR'
export const RESET_DATA: 'report/RESET_DATA' = 'report/RESET_DATA'

export const OPEN_DAILY_DETAILS: 'report/OPEN_DAILY_DETAILS' = 'report/OPEN_DAILY_DETAILS'
export const CLOSE_DAILY_DETAILS: 'report/CLOSE_DAILY_DETAILS' = 'report/CLOSE_DAILY_DETAILS'
export const FETCH_DETAILS_PENDING: 'report/FETCH_DETAILS_PENDING' = 'report/FETCH_DETAILS_PENDING'
export const FETCH_DETAILS_SUCCESS: 'report/FETCH_DETAILS_SUCCESS' = 'report/FETCH_DETAILS_SUCCESS'
export const FETCH_DETAILS_ERROR: 'report/FETCH_DETAILS_ERROR' = 'report/FETCH_DETAILS_ERROR'

export const SET_START_DATE: 'report/SET_START_DATE' = 'report/SET_START_DATE'
export const SET_END_DATE: 'report/SET_END_DATE' = 'report/SET_END_DATE'
export const FETCH_SUMMARY_PENDING: 'report/FETCH_SUMMARY_PENDING' = 'report/FETCH_SUMMARY_PENDING'
export const FETCH_SUMMARY_SUCCESS: 'report/FETCH_SUMMARY_SUCCESS' = 'report/FETCH_SUMMARY_SUCCESS'
export const FETCH_SUMMARY_ERROR: 'report/FETCH_SUMMARY_ERROR' = 'report/FETCH_SUMMARY_ERROR'

type FilterUnion = 'web' | 'phone' | 'f2f'
export type ChartSampling = 'DAILY' | 'WEEKLY' | 'MONTHLY'
export type ChartType = 'LINE' | 'AREA'
export type DailyAggregateObject = {|
  web: number,
  f2f: number,
  phone: number,
|}
export type DailyAggregateObjectList = {
  [key: string]: DailyAggregateObject,
}

export type DailyDetailsObject = {
  id_medico: string,
  data_visita: string,
  prodotto: string,
  canale: string,
  area: string,
  isf: string,
  call_experience: string,
  cognome: string,
  nome: string,
}
export type DailyDetailsObjectList = {
  [key: any]: Array<DailyDetailsObject>,
}
export type BrushState = {|
  startIndex: number,
  endIndex: number,
|}

type ACTION_TOGGLE_FILTER = {| type: typeof TOGGLE_FILTER, payload: FilterUnion |}
type ACTION_CHANGE_CHART_SAMPLING = {| type: typeof CHANGE_CHART_SAMPLING, payload: ChartSampling |}
type ACTION_CHANGE_CHART_TYPE = {| type: typeof CHANGE_CHART_TYPE, payload: ChartType |}
type ACTION_CHANGE_CHART_BRUSH_STATE = {| type: typeof CHANGE_CHART_BRUSH_STATE, payload: BrushState |}
type ACTION_CHANGE_REPORT_START_DATE = {| type: typeof CHANGE_REPORT_START_DATE, payload: string |}
type ACTION_FETCH_DATA_PENDING = {| type: typeof FETCH_DATA_PENDING |}
type ACTION_FETCH_DATA_SUCCESS = {| type: typeof FETCH_DATA_SUCCESS, payload: DailyAggregateObjectList |}
type ACTION_FETCH_DATA_ERROR = {| type: typeof FETCH_DATA_ERROR, payload: NetError |}
type ACTION_RESET_DATA = {| type: typeof RESET_DATA |}

type ACTION_OPEN_DAILY_DETAILS = {| type: typeof OPEN_DAILY_DETAILS, payload: string |}
type ACTION_CLOSE_DAILY_DETAILS = {| type: typeof CLOSE_DAILY_DETAILS |}
type ACTION_FETCH_DETAILS_PENDING = {| type: typeof FETCH_DETAILS_PENDING |}
type ACTION_FETCH_DETAILS_SUCCESS = {| type: typeof FETCH_DETAILS_SUCCESS, payload: DailyDetailsObjectList |}
type ACTION_FETCH_DETAILS_ERROR = {| type: typeof FETCH_DETAILS_ERROR, payload: NetError |}

type ACTION_SET_START_DATE = {| type: typeof SET_START_DATE, payload: moment$Moment |}
type ACTION_SET_END_DATE = {| type: typeof SET_END_DATE, payload: moment$Moment |}
type ACTION_FETCH_SUMMARY_PENDING = {| type: typeof FETCH_SUMMARY_PENDING |}
type ACTION_FETCH_SUMMARY_SUCCESS = {| type: typeof FETCH_SUMMARY_SUCCESS, payload: CardSummary |}
type ACTION_FETCH_SUMMARY_ERROR = {| type: typeof FETCH_SUMMARY_ERROR, payload: NetError |}

export type ReportAction =
  | ACTION_TOGGLE_FILTER
  | ACTION_CHANGE_CHART_SAMPLING
  | ACTION_CHANGE_CHART_TYPE
  | ACTION_CHANGE_CHART_BRUSH_STATE
  | ACTION_CHANGE_REPORT_START_DATE
  | ACTION_FETCH_DATA_PENDING
  | ACTION_FETCH_DATA_SUCCESS
  | ACTION_FETCH_DATA_ERROR
  | ACTION_RESET_DATA
  | ACTION_OPEN_DAILY_DETAILS
  | ACTION_CLOSE_DAILY_DETAILS
  | ACTION_FETCH_DETAILS_PENDING
  | ACTION_FETCH_DETAILS_SUCCESS
  | ACTION_FETCH_DETAILS_ERROR
  | ACTION_SET_START_DATE
  | ACTION_SET_END_DATE
  | ACTION_FETCH_SUMMARY_PENDING
  | ACTION_FETCH_SUMMARY_SUCCESS
  | ACTION_FETCH_SUMMARY_ERROR

type Statuses = 'NEW' | 'PENDING' | 'SUCCESS' | 'ERROR'
const statuses = {
  NEW: 'NEW',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
}

type ReportState_ = {|
  loading: Statuses,
  modalLoading: Statuses,
  reportStartDate: string,
  showWeb: boolean,
  showF2F: boolean,
  showPhone: boolean,
  chartSampling: ChartSampling,
  chartType: ChartType,
  chartBrushState: BrushState,
  data: DailyAggregateObjectList,
  summary: CardSummary | Object,
  selectedDay: string,
  selectedDayDetails: DailyDetailsObjectList,
  startDate: moment$Moment,
  endDate: moment$Moment,
|}
export type ReportState = $Shape<ReportState_>

// Initial state
const initialSummary = {
  WEB: { visits: 0, rate: 0 },
  F2F: { visits: 0, rate: 0 },
  PHONE: { visits: 0, rate: 0 },
  total: { visits: 0, rate: 0 },
  wave: { num_waves: 0, last_wave: 0, visits_last_wave: 0 },
}

export const initialState: ReportState = {
  loading: statuses.NEW,
  modalLoading: statuses.NEW,
  reportStartDate: '',
  showWeb: true,
  showF2F: true,
  showPhone: true,
  chartSampling: 'DAILY',
  chartType: 'AREA',
  chartBrushState: { startIndex: 0, endIndex: 0 },
  data: {},
  summary: initialSummary,
  selectedDay: '',
  selectedDayDetails: { WEB: [], PHONE: [], F2F: [] },
  startDate: moment().startOf('month'),
  endDate: moment(),
}

// Reducer
export const reducer = (state: ReportState = initialState, action: ReduxAction): ReportState => {
  switch (action.type) {
    case TOGGLE_FILTER:
      let stateKey = ''
      switch (action.payload) {
        case 'web':
          stateKey = 'showWeb'
          break
        case 'phone':
          stateKey = 'showPhone'
          break
        default:
          stateKey = 'showF2F'
      }
      return { ...state, [stateKey]: !state[stateKey] }
    case CHANGE_CHART_SAMPLING:
      return {
        ...state,
        chartSampling: action.payload,
        chartBrushState: { startIndex: 0, endIndex: 0 },
        reportStartDate: '',
      }
    case CHANGE_CHART_TYPE:
      return { ...state, chartType: action.payload }
    case CHANGE_CHART_BRUSH_STATE:
      return { ...state, chartBrushState: action.payload }
    case CHANGE_REPORT_START_DATE:
      return { ...state, reportStartDate: action.payload }
    case FETCH_DATA_PENDING:
      return { ...state, loading: statuses.PENDING, data: {}, reportStartDate: '' }
    case FETCH_DATA_ERROR:
      return { ...state, loading: statuses.ERROR }
    case FETCH_DATA_SUCCESS:
      return { ...state, loading: statuses.SUCCESS, data: action.payload }
    case RESET_DATA:
      return initialState

    case OPEN_DAILY_DETAILS:
      return { ...state, selectedDay: action.payload }
    case CLOSE_DAILY_DETAILS:
      return { ...state, selectedDay: '', selectedDayDetails: { WEB: [], PHONE: [], F2F: [] } }
    case FETCH_DETAILS_PENDING:
      return { ...state, modalLoading: statuses.PENDING }
    case FETCH_DETAILS_SUCCESS:
      return { ...state, modalLoading: statuses.SUCCESS, selectedDayDetails: action.payload }
    case FETCH_DETAILS_ERROR:
      return { ...state, modalLoading: statuses.ERROR }

    case SET_START_DATE:
      return { ...state, startDate: action.payload }
    case SET_END_DATE:
      return { ...state, endDate: action.payload }
    case FETCH_SUMMARY_PENDING:
      return { ...state, summary: initialSummary }
    case FETCH_SUMMARY_ERROR:
      return { ...state, loading: statuses.ERROR }
    case FETCH_SUMMARY_SUCCESS:
      return { ...state, summary: action.payload }
    default:
      return state
  }
}

// Action creators
export const toggleFilter = (filter: FilterUnion): ACTION_TOGGLE_FILTER => ({ type: TOGGLE_FILTER, payload: filter })
export const setReportStartDate = (reportStartDate: string): ACTION_CHANGE_REPORT_START_DATE => ({
  type: CHANGE_REPORT_START_DATE,
  payload: reportStartDate,
})
export const setChartSampling = (sampling: ChartSampling): ACTION_CHANGE_CHART_SAMPLING => ({
  type: CHANGE_CHART_SAMPLING,
  payload: sampling,
})
export const setChartType = (type: ChartType): ACTION_CHANGE_CHART_TYPE => ({
  type: CHANGE_CHART_TYPE,
  payload: type,
})
export const setChartBrushState = (brushState: BrushState): ACTION_CHANGE_CHART_BRUSH_STATE => ({
  type: CHANGE_CHART_BRUSH_STATE,
  payload: brushState,
})

export const openDailyDetails = (day: string): ACTION_OPEN_DAILY_DETAILS => ({ type: OPEN_DAILY_DETAILS, payload: day })
export const closeDailyDetails = (): ACTION_CLOSE_DAILY_DETAILS => ({ type: CLOSE_DAILY_DETAILS })

export const setStartDate = (startDate: moment$Moment): ACTION_SET_START_DATE => ({
  type: SET_START_DATE,
  payload: startDate,
})

export const setEndDate = (endDate: moment$Moment): ACTION_SET_END_DATE => ({
  type: SET_END_DATE,
  payload: endDate,
})

export const getSummaryData = (
  campaignName: string,
  startDate: string,
  endDate: string,
  showWeb: string,
  showF2F: string,
  showPhone: string
) => async (dispatch: Dispatch, getState: GetState) => {
  dispatch({ type: FETCH_SUMMARY_PENDING })
  try {
    let response = await authenticatedRequest.get(
      '/api/reports/' +
        campaignName +
        '/summary/' +
        startDate +
        '/' +
        endDate +
        '/' +
        showWeb +
        '/' +
        showF2F +
        '/' +
        showPhone
    )
    dispatch({ type: FETCH_SUMMARY_SUCCESS, payload: response.data.data })
  } catch (err) {
    dispatch({ type: FETCH_SUMMARY_ERROR, payload: err })
    dispatch(addErrorNotification(err.response.data.message))
  }
}

export const getDailyDetailedData = (campaignName: string, startDate: string, endDate: string) => async (
  dispatch: Dispatch,
  getState: GetState
) => {
  dispatch({ type: FETCH_DETAILS_PENDING })
  try {
    let response = await authenticatedRequest.get(
      '/api/reports/' + encodeURIComponent(campaignName) + '/daily_list/' + startDate + '/' + endDate
    )
    dispatch({ type: FETCH_DETAILS_SUCCESS, payload: response.data.data })
  } catch (err) {
    dispatch({ type: FETCH_DETAILS_ERROR, payload: err })
    dispatch(addErrorNotification(err.response.data.message))
  }
}

export const resetData = (): ACTION_RESET_DATA => ({ type: RESET_DATA })
export const getDailyAggregatedData = (campaignName: string) => async (dispatch: Dispatch, getState: GetState) => {
  dispatch({ type: FETCH_DATA_PENDING })
  try {
    let response = await authenticatedRequest.get(
      '/api/reports/' + encodeURIComponent(campaignName) + '/daily_aggregate'
    )
    dispatch({ type: FETCH_DATA_SUCCESS, payload: response.data.data })
  } catch (err) {
    dispatch({ type: FETCH_DATA_ERROR, payload: err })
    dispatch(addErrorNotification(err.response.data.message))
  }
}

// Selectors
export type AggregatedVisits = Array<{ date: string, name: string, web: number, f2f: number, phone: number }>
export const getDailyData = (state: ReduxState, startDate: moment$Moment, endDate: moment$Moment): AggregatedVisits => {
  let start = moment(startDate)
  let end = moment(endDate)
  let data = []
  let dates = Object.keys(state.reports.ui.data ? state.reports.ui.data : {}).map(d => parseInt(d, 10))
  if (dates.length) {
    let empty = { web: 0, f2f: 0, phone: 0 }

    while (start.isSameOrBefore(end)) {
      let k = start.format('YYYYMMDD')
      let name = start.format('DD-MMM')
      if (start.isBefore(moment())) {
        data.push({ date: k, name, ...(state.reports.ui.data[k] ? state.reports.ui.data[k] : { ...empty }) })
      } else {
        data.push({ date: k, name, ...empty })
      }
      start.add(1, 'day')
    }
  }
  return data
}

const _getWeeklyOrMonthlyData = (
  state: ReduxState,
  startDate: moment$Moment,
  endDate: moment$Moment,
  sampling: 'WEEKLY' | 'MONTHLY'
): AggregatedVisits => {
  let start = moment(startDate)
  let end = moment(endDate)
  let data = []
  let _data = {}
  let empty = { web: 0, f2f: 0, phone: 0 }
  let dates = Object.keys(state.reports.ui.data ? state.reports.ui.data : {}).map(d => parseInt(d, 10))

  if (dates.length) {
    while (start.isSameOrBefore(end)) {
      // SKIP FUTURE DATA!
      if (!start.isBefore(moment())) break
      let j = start.format('YYYYMMDD')
      let k =
        sampling === 'MONTHLY'
          ? moment(start)
              .startOf('month')
              .format('MM-YYYY')
          : moment(start)
              .startOf('isoweek')
              .format('W-YYYY')
      let oldValues = _data[k] ? _data[k] : { ...empty }
      let iterValues = { ...empty }
      if (start.isBefore(moment())) {
        iterValues = state.reports.ui.data[j] ? state.reports.ui.data[j] : { ...empty }
      }
      _data[k] = {
        web: oldValues.web + iterValues.web,
        phone: oldValues.phone + iterValues.phone,
        f2f: oldValues.f2f + iterValues.f2f,
      }
      start.add(1, 'day')
    }

    for (let d in _data) {
      if (sampling === 'MONTHLY') {
        let date = moment(d, 'MM-YYYY').format('YYYYMMDD')
        let name = moment(d, 'MM-YYYY').format('MMM YYYY')
        name = name.charAt(0).toUpperCase() + name.slice(1)
        data.push({ date, name, ..._data[d] })
      } else if (sampling === 'WEEKLY') {
        let date = moment(d, 'W-YYYY')
          .startOf('isoweek')
          .format('YYYYMMDD')
        let start = moment(d, 'W-YYYY')
          .startOf('isoweek')
          .format('DD/MM')
        let end = moment(d, 'W-YYYY')
          .endOf('isoweek')
          .format('DD/MM')
        data.push({ date, name: `${start} - ${end}`, ..._data[d] })
      }
    }
  }
  return data
}

export const getWeeklyData = (
  state: ReduxState,
  startDate: moment$Moment,
  endDate: moment$Moment
): AggregatedVisits => {
  return _getWeeklyOrMonthlyData(state, startDate, endDate, 'WEEKLY')
}

export const getMonthlyData = (
  state: ReduxState,
  startDate: moment$Moment,
  endDate: moment$Moment
): AggregatedVisits => {
  return _getWeeklyOrMonthlyData(state, startDate, endDate, 'MONTHLY')
}

export type ReportsSectionState = {
  ui: ReportState,
  grid: DataGridState,
}
export default combineReducers({
  ui: reducer,
  grid: createDataGridReducer('visitsDetailsReportGrid'),
})



// WEBPACK FOOTER //
// ./src/store/reports.js